    
<template>
    <div class="dashBox">
        <a-spin :spinning="tloading">
            <div style=" padding: 20px 0;">
                <a-row :gutter="16">
                    <a-col :span="4">
                        <a-card>
                            <a-statistic title="总计" :value="total"
                                :value-style="{ color: '#3f8600' }">
                                <template #prefix>
                                    <a-icon  class="wschartIcon" type="message" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic title="已发送" :value="totalsendct"
                                :value-style="{ color: '#3f8600' }">
                                <template #prefix>
                                    <a-icon  class="wschartIcon" type="message" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic title="未处理" :value="totaluntreatedct"  class="demo-class"
                                :value-style="{ color: '#3f8600' }">
                                <template #prefix>
                                    <a-icon  class="wschartIcon" type="exclamation-circle" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card @click="handleErrorView" class="linkCard">
                            <a-statistic title="失败" :value="totalfailct"  class="demo-class"
                                :value-style="{ color: '#3f8600',textDecoration :'underline' }">
                                <template #prefix>
                                    <a-icon  class="wschartIcon" type="close-circle" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic title="已触达" :value="totaltouchct"  class="demo-class"
                                :value-style="{ color: '#3f8600' }">
                                <template #prefix>
                                    <a-icon  class="wschartIcon" type="check-circle" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="4">
                        <a-card>
                            <a-statistic title="触达率" :value="touchproportion * 100" :precision="2" suffix="%"
                                :value-style="{ color: '#3f8600' }">
                                <template #prefix>
                                    <a-icon  class="wschartIcon" type="rise" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                </a-row>
            </div>

            <a-empty v-if="sendct_.length == 0" description="暂无数据" style="margin-top:80px;" />
            <div id="wschartID" style="width: 100%;"></div>


            <div style="padding:20px;">
                <a-table :columns="columns" :data-source="tableData" rowKey="classname" :pagination="false">
                </a-table>
            </div>
        </a-spin>
    </div>
</template>

<script>
const columns = [
    {
        title: '类别',
        dataIndex: 'classname',
    },
    {
        title: '总数',
        dataIndex: 'total',
    },
    {
        title: '平均',
        dataIndex: 'avg',
    },
    {
        title: '最高',
        dataIndex: 'max',
    },
    {
        title: '最低',
        dataIndex: 'min',
    },
]
export default {
    data() {
        return {
            chartSys:null,
            chartDate:[1],
            searchP:{
                channelcode:'',
                passwaytype:'',
            },
            sendct_:[],
            touchct_:[],
            untreatedct_:[],
            failct_:[],
            time_:[],
            tloading:false,
            total:0,
            totalsendct:0,
            totaluntreatedct:0,
            totalfailct:0,
            totaltouchct:0,
            touchproportion:0,

            tableData:[],
            columns
        }
    },

    methods: {
        handleErrorView(){
            console.log(1)
            this.$router.push({
                path: "/mcmsmanager/message/wshistory",
                query: {
                    status:"00",
                    ...this.searchP
                }
            });
        },
        resetData(){
            this.sendct_ = [];
            this.touchct_ = [];
            this.untreatedct_ = [];
            this.failct_ = [];
            this.time_ = [];
        },
        loadData(searchP){
            if(searchP){
                this.searchP = searchP
            }
            let that = this;
            that.tableData = [];
            that.tloading = true;
            that.resetData();
            let params = {
                channelcode:that.searchP.channelcode,
                messagestypecode:that.searchP.messagestypecode,
                querytype:that.searchP.selectedTimeRange.split('~')[2],
                starttime:that.searchP.selectedTimeRange.split('~')[0],
                endtime:that.searchP.selectedTimeRange.split('~')[1],
            };
            that.$store.dispatch({
                type: "mcmsmanager/queryTouchCt",
                params:params
            }).then((res)=>{
                that.tloading = false
                if(res.status == 200 && res.data.success == '1'){
                    let res_data = res.data.data.items;
                    res_data.forEach(element => {
                        that.sendct_.push(element.sendct);
                        that.touchct_.push(element.touchct);
                        that.untreatedct_.push(element.untreatedct);
                        that.failct_.push(element.failct);
                        that.time_.push(element.time);
                    });
                    that.total = res.data.data.total;
                    that.totalsendct = res.data.data.totalsendct;
                    that.totaluntreatedct = res.data.data.totaluntreatedct;
                    that.totalfailct = res.data.data.totalfailct;
                    that.totaltouchct = res.data.data.totaltouchct;
                    that.touchproportion = res.data.data.touchproportion;

                    //组装表格
                    let tempData = res.data.data;
                    that.tableData.push({
                        classname:'总计',
                        total:tempData.total,
                        avg:tempData.avgtotalct,
                        max:tempData.maxtotalct,
                        min:tempData.mintotalct,
                    })
                    that.tableData.push({
                        classname:'已发送',
                        total:tempData.totalsendct,
                        avg:tempData.avgsendct,
                        max:tempData.maxsendct,
                        min:tempData.minsendct,
                    })
                    that.tableData.push({
                        classname:'未处理',
                        total:tempData.totaluntreatedct,
                        avg:tempData.avguntreatedct,
                        max:tempData.maxuntreatedct,
                        min:tempData.minuntreatedct,
                    })
                    that.tableData.push({
                        classname:'失败',
                        total:tempData.totalfailct,
                        avg:tempData.avgfailct,
                        max:tempData.maxfailct,
                        min:tempData.minfailct,
                    })
                    that.tableData.push({
                        classname:'已触达',
                        total:tempData.totaltouchct,
                        avg:tempData.avgtouchct,
                        max:tempData.maxtouchct,
                        min:tempData.mintouchct,
                    })

                    that.analystData();
                }
            }).catch(() => {
                that.tloading = false
            });
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("wschartID").style.height = "300px";
            that.chartSys = that.$echarts.init(document.getElementById("wschartID"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
            });
            
        },
        getDatailOption(){
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    top:'bottom',
                    data: ['已发送', '已触达','未处理','失败']
                },
                grid: {
                    top: '3%',
                    lett:'3%'
                },

                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.time_
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '已发送',
                        type: 'line',
                        data: this.sendct_
                    },
                    {
                        name: '已触达',
                        type: 'line',
                        data: this.touchct_
                    },
                    {
                        name: '未处理',
                        type: 'line',
                        data: this.untreatedct_
                    },
                    {
                        name: '失败',
                        type: 'line',
                        data: this.failct_
                    },
                ]
            };
            return option;
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

}
</script>

<style scoped>
    .wschartIcon{
        margin-right: 8px;
    }

    .linkCard{
        cursor: pointer;
    }
</style>

<style>
    .ant-statistic-title{
        font-size: 16px;
    }
</style>

